import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { createStyles, FormHelperText, withStyles } from "@material-ui/core";
import { DateRangeOutlined } from "@material-ui/icons";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { checkRequired } from "./utils";

var styles = function styles(theme) {
  return createStyles({
    adornedEnd: {
      paddingRight: 0
    },
    outlinedRoot: {
      marginTop: theme.spacing(-1.5),
      marginBottom: theme.spacing(0.5)
    },
    outlinedInput: {
      paddingTop: theme.spacing(1.32),
      paddingBottom: theme.spacing(1.32)
    },
    outlinedLabel: {
      transform: 'translate(14px, 12px) scale(1)'
    },
    error: {
      marginTop: 0,
      marginLeft: 0
    }
  });
};

var Datepicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Datepicker, _React$Component);

  function Datepicker() {
    _classCallCheck(this, Datepicker);

    return _possibleConstructorReturn(this, _getPrototypeOf(Datepicker).apply(this, arguments));
  }

  _createClass(Datepicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          meta = _this$props.meta,
          hasError = _this$props.hasError,
          touched = _this$props.touched,
          value = _this$props.value,
          setValue = _this$props.setValue,
          status = _this$props.status,
          classes = _this$props.classes;
      var isDisabled = status === 'DISABLED' || meta.disabled;
      var isRequired = checkRequired(this.props);
      var minDate = meta.minDate || undefined;
      var maxDate = meta.maxDate || undefined;
      if (typeof minDate === 'function') minDate = minDate();
      if (typeof maxDate === 'function') maxDate = maxDate();
      return React.createElement(React.Fragment, null, React.createElement(KeyboardDatePicker, {
        format: meta.format || 'dd.MM.yyyy',
        views: meta.views || ["date"],
        label: meta.label,
        value: value || null,
        onChange: function onChange(date) {
          return date === 'Invalid Date' ? setValue(null) : setValue(date);
        },
        keyboardIcon: React.createElement(DateRangeOutlined, {
          fontSize: 'small'
        }),
        mask: meta.mask || "__.__.____",
        invalidDateMessage: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B",
        fullWidth: true,
        inputVariant: "outlined",
        clearable: true,
        autoOk: true,
        cancelLabel: "\u041E\u0442\u043C\u0435\u043D\u0430",
        clearLabel: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
        okLabel: "Ok",
        margin: "dense",
        required: isRequired,
        disabled: isDisabled,
        minDate: minDate,
        minDateMessage: meta.minDateMessage || 'Дата не должна быть раньше минимальной даты',
        maxDate: maxDate,
        maxDateMessage: meta.maxDateMessage || 'Дата не должна быть после максимальной даты',
        InputProps: {
          classes: {
            adornedEnd: classes.adornedEnd
          }
        }
      }), touched && hasError("required") && React.createElement(FormHelperText, {
        className: classes.error,
        error: true
      }, "\u041F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"));
    }
  }]);

  return Datepicker;
}(React.Component);

export default withStyles(styles, {
  name: 'Datepicker'
})(Datepicker);